import CustomElement from '../core/custom.js'
import Emitter from '../core/emitter.js'
import App from '../stores/app.js'

const VIEWS = {
  immersive: 'immersive',
  list: 'list'
}

export default window.customElements.define(
  'portfolio-view',
  class extends CustomElement {
    constructor() {
      super()

      this.events = {
        ...this.events,
        'click .js-portfolio-view-toggle': 'onClickToggle',
        'click .js-portfolio-view-tag': 'onClickTag'
      }
    }

    connectedCallback() {
      super.connectedCallback()
      this.$tagBtns = this.querySelectorAll('.js-portfolio-view-tag')
      const view = this.hasAttribute('mode') ? this.getAttribute('mode') : 'list' 
      this.setData({view})
      requestAnimationFrame(()=>{
        if (view == VIEWS.immersive) {
          App.lenis.stop()
          App.lenis.scrollTo('top', {
            duration: 0.8,
            force: true,
            easing: (t) =>
              t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2 // https://easings.net/en#easeInOutQuad
          })
          setTimeout(()=>{
            App.lenis.stop()
            console.log('STOP SCROLL')
          }, 1000)
        } 
        else {
          App.lenis.start()
        }
      })
      setTimeout(() => {
        
        Emitter.emit('immersive-view', view == VIEWS.immersive)
      },100)
    }

    disconnectedCallback() {
      super.disconnectedCallback()
    }

    onClickToggle(e) {
      e.preventDefault()

      const view = this.view == VIEWS.immersive ? VIEWS.list : VIEWS.immersive

      this.setData({
        view
      })
      Emitter.emit('immersive-view', view == VIEWS.immersive)

      requestAnimationFrame(() => {
        if (view == VIEWS.immersive) {
          App.lenis.stop()
          App.lenis.scrollTo('top', {
            duration: 0.8,
            force: true,
            easing: (t) =>
              t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2 // https://easings.net/en#easeInOutQuad
          })
        } else {
          App.lenis.start()
        }
      })
    }

    onClickTag(e) {
      e.preventDefault()

      this.$tagBtns.forEach((el) => el.classList.remove('is-active'))

      this.setData({ tag: e.target.dataset.tag })

      e.target.classList.add('is-active')
    }
  }
)
